import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";

const portalApi = axios.create({ baseURL: API, withCredentials: true });

export default function PortalVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setError("Missing token"); return; }
    portalApi
      .get(`/portal/auth/verify?token=${encodeURIComponent(token)}`)
      .then(() => {
        setState("ok");
        setTimeout(() => navigate("/portal", { replace: true }), 800);
      })
      .catch((e) => {
        setState("error");
        setError(e?.response?.data?.detail || "Invalid or expired link");
      });
  }, [params, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="portal-verify-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8 shadow-sm text-center">
        {state === "verifying" && (
          <div data-testid="portal-verify-loading">
            <Spinner size={32} className="animate-spin text-slate-400 mx-auto mb-3" />
            <div className="text-slate-500 text-sm">Signing you in…</div>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="portal-verify-success">
            <CheckCircle size={40} weight="fill" className="text-emerald-500 mx-auto mb-3" />
            <div className="text-slate-900 font-semibold mb-1">Signed in</div>
            <div className="text-slate-500 text-sm">Redirecting to your portal…</div>
          </div>
        )}
        {state === "error" && (
          <div data-testid="portal-verify-error">
            <XCircle size={40} weight="fill" className="text-red-500 mx-auto mb-3" />
            <div className="text-slate-900 font-semibold mb-1">Link not valid</div>
            <div className="text-slate-500 text-sm mb-6">{error}</div>
            <a href="/portal/login" className="text-sm text-red-700 underline">Request a new link</a>
          </div>
        )}
      </div>
    </div>
  );
}
